import moment from "moment";
import { APPLICATION_STATUS, SYNC_FIELDS_STATUS_DICT } from "constants/opekepe";

export class MyFarmersDto {
  static fromApi(data) {
    return data.map((farmer) => {
      const registeredKydUser = !(
        Boolean(farmer.lastLogin) ||
        farmer.mobileVerified ||
        farmer.connectedToOpekepe ||
        farmer.syncedToOpekepe
      );
      let status = "registeredKydUser";
      if (farmer.syncedToOpekepe) {
        status = "syncedFields";
      } else if (farmer.connectedToOpekepe) {
        status = "opekepe";
      } else if (farmer.mobileVerified) {
        status = "otp";
      } else if (Boolean(farmer.lastLogin)) {
        status = "camvioConnection";
      }

      const latestApplication = farmer?.opekepeSyncStats?.[0];
      let applicationStatus = "";
      if (latestApplication?.applicationStatusCode in APPLICATION_STATUS) {
        applicationStatus =
          APPLICATION_STATUS[latestApplication.applicationStatusCode];
      }

      return {
        id: farmer.id,
        lastName: farmer.lastName || "",
        firstName: farmer.firstName || "",
        taxNumber: farmer.taxNumber || "",
        phone: farmer.phone || "",
        email: farmer.email || "",
        camvioConnection: Boolean(farmer.lastLogin),
        otp: farmer.mobileVerified,
        opekepe: farmer.connectedToOpekepe,
        syncedFields: farmer.syncedToOpekepe,
        registeredKydUser,
        status,
        opekepeApplications: farmer?.opekepeSyncStats?.map((app) => ({
          status: SYNC_FIELDS_STATUS_DICT[app?.syncStatus],
          totalFields: (app?.numSyncFields || 0) + (app?.numNewFields || 0),
          totalCrops: app?.numUniqueCrops || 0,
          year: app?.year,
          dateSynced: app?.updatedAt
            ? moment(app?.updatedAt).toISOString()
            : moment(app?.createdAt).toISOString(),
        })),
        availableSubscriptionYears: farmer?.opekepeSubscriptionYears || [],
        applicationStatus,
        documentCodes: latestApplication?.documentTypeCodesList || [],
        smartApp: latestApplication?.smartAgricultureToolCodeDisplay || "",
        amountOwed: farmer?.amountOwed ?? null,
        hasPaidSubscription: Boolean(farmer?.hasPaidSubscription),
        latestInvoiceId: farmer?.latestInvoiceId ?? null,
        pendingRfCode: farmer?.pendingRfCode ?? null,
        spdInvoice: farmer?.spdInvoice ?? null,
        totalOwnedAreaM2: farmer?.totalOwnedAreaM2 ?? 0,
        billableStremmata: farmer?.billableStremmata ?? 0,
        fieldsCount: farmer?.fieldsCount ?? 0,
      };
    });
  }
}
